module.exports = __webpack_public_path__ + "img/18_003.8bd8ddfc.webp";